import {
  BadgeCheck,
  FileCheck2,
  FileQuestion,
  FileSearch2,
  MessageCircleQuestion,
  MessagesSquare,
  Route,
  Scale,
} from "lucide-react";
import { ProductShell } from "@tribunalea/ui";
import {
  APPLICATION_IDS,
  canAccessApplication,
  canAccessTool,
  TOOL_IDS,
  TRIBUNALEA_APPLICATIONS,
} from "@tribunalea/shared";

const navigation = [
  {
    label: "Civita",
    items: [
      { to: "/justiniano", label: "Justiniano", icon: MessageCircleQuestion },
      { to: "/entender-documento", label: "Entender un documento", icon: FileSearch2, toolId: TOOL_IDS.CIVITA_UNDERSTAND_DOCUMENT },
      { to: "/resolver-problema", label: "Resolver un problema", icon: Route, toolId: TOOL_IDS.CIVITA_RESOLVE_PROBLEM },
      { to: "/revisar-antes-de-firmar", label: "Revisar antes de firmar", icon: FileCheck2, toolId: TOOL_IDS.CIVITA_REVIEW_BEFORE_SIGNING },
      { to: "/seguir-expediente", label: "Seguir mi expediente", icon: FileQuestion, toolId: TOOL_IDS.CIVITA_FOLLOW_CASE },
      { to: "/preparar-conversacion", label: "Preparar una conversación difícil", icon: MessagesSquare, toolId: TOOL_IDS.CIVITA_PREPARE_CONVERSATION },
      { to: "/verificar-legitimidad", label: "Verificar si es legítimo", icon: BadgeCheck, toolId: TOOL_IDS.CIVITA_VERIFY_LEGITIMACY },
      { to: "/encontrar-abogado", label: "Encontrar un abogado", icon: Scale, toolId: TOOL_IDS.CIVITA_FIND_LAWYER },
    ],
  },
];

const portalUrl = import.meta.env.DEV
  ? "http://localhost:3000/portal"
  : "https://tribunalea.com/portal";

const accountUrl = import.meta.env.VITE_ACCOUNT_URL || (
  import.meta.env.DEV
    ? "http://localhost:5175"
    : "https://account.tribunalea.com"
);

const products = [
  {
    applicationId: APPLICATION_IDS.PRAXIS,
    name: "Praxis",
    href: import.meta.env.VITE_PRAXIS_URL || (import.meta.env.DEV ? "http://localhost:5173" : "https://praxis.tribunalea.com"),
  },
  {
    applicationId: APPLICATION_IDS.INSTRUMENTA,
    name: "Instrumenta",
    href: import.meta.env.VITE_INSTRUMENTA_URL || (import.meta.env.DEV ? "http://localhost:5174" : "https://instrumenta.tribunalea.com"),
  },
  {
    applicationId: APPLICATION_IDS.LEXIA,
    name: "Lexia",
    href: import.meta.env.VITE_LEXIA_URL || (import.meta.env.DEV ? "http://localhost:5176" : "https://lexia.tribunalea.com"),
  },
  {
    applicationId: APPLICATION_IDS.CIVITA,
    name: "Civita",
    href: import.meta.env.VITE_CIVITA_URL || (import.meta.env.DEV ? "http://localhost:5179" : "https://civita.tribunalea.com"),
  },
];

export function AppShell({
  access,
  accountAvatar,
  accountControls,
  authEnabled,
  children,
}) {
  const visibleNavigation = navigation.map((section) => ({
    ...section,
    items: section.items.filter((item) => (
      !item.toolId || canAccessTool(access, item.toolId)
    )),
  })).filter((section) => section.items.length);
  const visibleProducts = products.filter((product) => (
    canAccessApplication(access, product.applicationId)
  ));
  const hiddenProductNames = TRIBUNALEA_APPLICATIONS
    .filter(({ id }) => !canAccessApplication(access, id))
    .map(({ name }) => name);

  return (
    <ProductShell
      productName="Civita"
      products={visibleProducts}
      hiddenProductNames={hiddenProductNames}
      navigation={visibleNavigation}
      portalUrl={portalUrl}
      accountSettingsHref={`${accountUrl}/creditos`}
      accountAvatar={accountAvatar}
      workspace={access?.workspace}
      accountControls={accountControls}
      demo={!authEnabled}
    >
      {children}
    </ProductShell>
  );
}
